import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { SkillsUsage } from '../skills/models/skills-usage.model';
import { Skill } from '../skills/models/skills.model';

const BASE_URL = `${environment.apiConfig.url}/admin/skills`;

@Injectable()
export class AdminSkillService {
  constructor(private http: HttpClient) {}

  loadSkills() {
    return this.http.get<Skill[]>(BASE_URL);
  }

  createSkill(values: Record<string, unknown>) {
    return this.http.post<Skill>(BASE_URL, values);
  }

  updateSkill(values: Record<string, unknown>, skillId: string) {
    return this.http.patch<Skill>(`${BASE_URL}/${skillId}`, values);
  }

  deleteSkill(skillId: string) {
    return this.http.delete<Skill>(`${BASE_URL}/${skillId}`);
  }

  getSkillsUsage() {
    return this.http.get<SkillsUsage[]>(`${BASE_URL}/usage`);
  }
}
